import millify from "millify";
import VoiceImage from "../VoiceImage";
import React from "react";

const SearchVoiceItem = ({ model, isSelected, addVoice }) => {
  return (
    <div
      onClick={() => {
        addVoice(model);
      }}
      key={model?._id}
      className={`tw-flex tw-shadow tw-h-max tw-p-2 tw-w-full tw-cursor-pointer tw-rounded-2xl tw-gap-2 tw-flex tw-truncate hover:tw-bg-gray-50 tw-transition-all tw-border tw-border-solid tw-border-gray-100 tw-items-center tw-gap-1 ${isSelected && "tw-border-purple-400 tw-border tw-bg-purple-50 hover:tw-bg-purple-100"}`}
    >
      <VoiceImage model={model} size={40} className="tw-rounded-xl" />

      <div className="tw-truncate">
        <div className="tw-font-bold tw-text-left tw-w-full tw-truncate tw-text-sm">
          {model?.artistname}
        </div>
        <div className="tw-text-xs tw-font-bold tw-text-black/40">
          {millify(model?.uses)} Uses | By {model?.user?.username}
        </div>
      </div>
    </div>
  );
};

export default SearchVoiceItem;
